<template>
  <div>
    <!-- 使用监控 -->
    <div class="module">
      <a @click="$router.push('views/UseMonitoring/P0101')" style="cursor: pointer;">
        <div style="display: flex; align-items: center">
          <img class="imgOne" src="../../assets/useMonitor.svg" />
        </div>
        {{$t('mainPage.useMonitor')}}
      </a>
    </div>

    <!-- 客户管理 -->
    <div class="module">
      <a @click="$router.push('views/CustomerInfoBase/P0212')"
         style="cursor: pointer;">
        <div style="display: flex; align-items: center;overflow: hidden;overflow-x:auto">
          <img class="imgTwo"
               src="../../assets/customerManagement1.svg" />
        </div>
        {{$t('mainPage.customerManagement')}}
      </a>
    </div>

    <!-- 绿夹克 -->
    <div class="module">
      <a @click="$router.push('views/GreenJacketForum/P0301')"
         style="cursor: pointer;overflow: hidden;overflow-x:auto">
        <div style="display: flex; align-items: center;overflow: hidden;overflow-x:auto">
          <img class="imgThree"
               src="../../assets/greenJacketForum.svg" />
        </div>
        {{$t('mainPage.greenJacketForum')}}
      </a>
    </div>
    <!-- 绿夹克 -->
    <div class="module">
      <a @click="$router.push('views/Marketing/EmailMarketing/P0401')"
         style="cursor: pointer;overflow: hidden;overflow-x:auto">
        <div style="display: flex; align-items: center;overflow: hidden;overflow-x:auto">
          <img class="imgThree"
               src="../../assets/marketingPromotion.svg" />
        </div>
        {{$t('mainPage.marketingPromotion')}}
      </a>
    </div>
    <div class="div_footer">
      <p class="p_introduce">
        <a href="https://beian.miit.gov.cn/"
           target="_blank"
           style="cursor: pointer;color:#797979;text-decoration:none;">苏ICP备13035339号-5</a>
      </p>
    </div>
  </div>

</template>
<script>

export default {
  data () {
    return {
      company: '',
    }
  },
  methods: {
  },

  created () {

  },
}
</script>
<style scoped>
.imgOne {
  /* width="201px" height="201px" */
  width: 201px;
  height: 201px;
}
.imgTwo {
  /* width="181px" height="181px" */
  width: 181px;
  height: 181px;
}
.imgThree {
  /* width="165px" height="165px" */
  width: 165px;
  height: 165px;
}
.module {
  /* display: block; */
  float: left;
  width: 19%;
  height: 285px;
  /* height: 5%; */
  text-align: center;
  /* margin: 80px 3%; */
  margin:3%;
}
.module div {
  height: 264px;
}
.more {
  line-height: 288px;
}
@media screen and (max-height: 800px) {
  #main {
    height: 477px;
  }
  .module {
    float: left;
    width: 19%;
    /* height: 3%; */
    text-align: center;
    /* margin: 80px 6%; */
    margin:3%;
  }
  .module div {
    height: 172px;
    width: 100%;
  }
  .more {
    line-height: 164px;
  }
  .imgOne {
    /* width="164px" height="164px" */
    width: 170.5px;
    height: 170.5px;
  }
  .imgTwo {
    /* width="181px" height="181px" */
    width: 160.5px;
    height: 160.5px;
  }
  .imgThree {
    /* width="165px" height="165px" */
    width: 145px;
    height: 145px;
  }
}
@media screen and (max-height: 668px) {
  #main {
    height: 477px;
  }
  .module {
    float: left;
    width: 19%;
    height: 153px;
    /* height: 4%; */
    text-align: center;
    /* margin: 80px 3%; */
    margin:3%;
  }
  .module div {
    height: 132px;
  }
  /* .more {
    line-height: 124px;
  } */
  .imgOne {
    /* width="164px" height="164px" */
    width: 162px;
    height: 162px;
  }
  .imgTwo {
    /* width="181px" height="181px" */
    width: 120.5px;
    height: 120.5px;
  }
  .imgThree {
    /* width="165px" height="165px" */
    width: 110px;
    height: 110px;
  }
}
.module a img {
  align-items: center;
  margin: 0 auto;
}
.module a {
  vertical-align: middle;
  text-decoration: none;
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: #6b6b6b;
}
.module a:hover {
  text-decoration: none;
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  font-style: normal;
  font-size: 18px;
  height: auto;
}
/* ---------------------------------------------------- */

.div_footer {
  position: fixed;
  text-align: center;
  bottom: 15px;
  margin: 0 auto;
  width: 87%;
}

.p_introduce {
  width: 100%;
  line-height: 22px;
  font-size: 10px;
  text-align: center;
  color: #797979;
}
</style>


// WEBPACK FOOTER //
// src/views/Index/P0000.vue